<template>
  <v-btn
    border
    color="white"
    density="comfortable"
    icon="mdi-cog-outline"></v-btn>
</template>

<script lang="ts">
export default {
  name: 'TableColumnPickerButton',
}
</script>
